import React from 'react';
import styled from 'styled-components';

export const Icon = styled.i`
  font-size: 30px;
`;

export const UserIcon = () => <Icon className="fas fa-user-circle" />;
